import { DEFAULT_GRID_SIZE } from 'libs/util/src/lib/constants/common.constants';
import {
  ACCEPT_HOO_REQUEST,
  ACCEPT_HOO_REQUEST_FAILURE,
  ACCEPT_HOO_REQUEST_SUCCESS,
  DELETE_HOO_REQUEST,
  DELETE_HOO_REQUEST_FAILURE,
  DELETE_HOO_REQUEST_SUCCESS,
  FETCH_LOCATIONS_FOR_REQUESTOR,
  FETCH_UNPLANNED_LOCATIONS,
  FETCH_UNPLANNED_LOCATIONS_SUCCESS,
  FETCH_UNPLANNED_LOCATIONS_FAILURE,
  FETCH_LOCATIONS_FOR_REQUESTOR_FAILURE,
  FETCH_LOCATIONS_FOR_REQUESTOR_SUCCESS,
  FETCH_REQUESTORS,
  FETCH_REQUESTORS_FAILURE,
  FETCH_REQUESTORS_SUCCESS,
  FETCH_REQUEST_REASONS,
  FETCH_REQUEST_REASONS_SUCCESS,
  FETCH_REQUEST_REASONS_FAILURE,
  FETCH_REQUEST_TYPES,
  FETCH_REQUEST_TYPES_SUCCESS,
  FETCH_REQUEST_TYPES_FAILURE,
  REJECT_HOO_REQUEST,
  REJECT_HOO_REQUEST_FAILURE,
  REJECT_HOO_REQUEST_SUCCESS,
  SAVE_HOO_REQUEST,
  SAVE_HOO_REQUEST_FAILED,
  SEARCH_HOO,
  SEARCH_HOO_FAILED,
  SEARCH_HOO_SUCCESS,
  SET_SEARCH_HOO,
  EXPORT_HOO_REQUESTS,
  EXPORT_HOO_REQUESTS_SUCCESS,
  EXPORT_HOO_REQUESTS_FAILURE,
} from './actions';

export const defaultSearchHooRequests = {
  page: 0,
  size: DEFAULT_GRID_SIZE,
  statuses: ['Pending'],
  isAllRecords: true,
};

type TState = {
  requests: [];
  loading: boolean;
  error: any;
  search: any;
  requestors: any[];
  locations: any[];
  unplannedLocations: any[];
  allRequestorData: any[];
  loadingRequestors: boolean;
  loadingLocations: boolean;
  reasons: any[];
  hoursOptions: string[];
  requestReasons: any[];
  requestTypes: any[];
  loadingRequestReasons: boolean;
  loadingRequestTypes: boolean;
  exportLoading: boolean;
};

const initialState: TState = {
  requests: [],
  loading: false,
  reasons: [{ label: 'Other', value: 'Other' }],
  error: null,
  search: defaultSearchHooRequests,
  requestors: [],
  locations: [],
  unplannedLocations: [],
  allRequestorData: [],
  loadingRequestors: false,
  loadingLocations: false,
  requestReasons: [],
  requestTypes: [],
  loadingRequestReasons: false,
  loadingRequestTypes: false,
  exportLoading: false,
  hoursOptions: [
    '7:00 AM-4:00 PM',
    '7:00 AM-5:00 PM',
    '7:00 AM-6:00 PM',
    '8:00 AM-1:00 PM',
    '8:00 AM-2:00 PM',
    '8:00 AM-3:00 PM',
    '8:00 AM-4:00 PM',
    '8:00 AM-5:00 PM',
    '8:30 AM-5:00 PM',
    '8:30 AM-5:30 PM',
    '8:00 AM-6:00 PM',
    '8:00 AM-7:00 PM',
    '9:00 AM-3:00 PM',
    '9:00 AM-4:00 PM',
    '9:00 AM-5:00 PM',
    '9:00 AM-6:00 PM',
    '9:00 AM-7:00 PM',
    '9:00 AM-8:00 PM',
    '10:00 AM-5:00 PM',
    '10:00 AM-6:00 PM',
    '10:00 AM-7:00 PM',
    '10:00 AM-8:00 PM',
    '10:00 AM-9:00 PM',
    '11:00 AM-5:00 PM',
    '11:00 AM-7:00 PM',
    '11:00 AM-8:00 PM',
    '12:00 PM-5:00 PM',
    '12:00 PM-6:00 PM',
    'Standard HOO',
    'CLOSED',
  ],
};

export const hooAccomodationsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_SEARCH_HOO:
      return {
        ...state,
        search: { ...state.search, ...payload },
      };
    case SEARCH_HOO:
      return {
        ...state,
        loading: true,
      };
    case SEARCH_HOO_SUCCESS:
      return {
        ...state,
        loading: false,
        requests: payload.contents || [],
      };
    case SEARCH_HOO_FAILED:
      return {
        ...state,
        loading: false,
        error: payload,
        requests: [],
      };
    case FETCH_REQUESTORS:
      return { ...state, loadingRequestors: true, error: null };
    case FETCH_REQUESTORS_SUCCESS:
      return {
        ...state,
        loadingRequestors: false,
        requestors: payload.requestors,
        allRequestorData: payload.allData,
      };
    case FETCH_REQUESTORS_FAILURE:
      return { ...state, loadingRequestors: false, error: payload };
    case FETCH_LOCATIONS_FOR_REQUESTOR:
      return { ...state, loadingLocations: true, error: null };
    case FETCH_LOCATIONS_FOR_REQUESTOR_SUCCESS:
      return { ...state, loadingLocations: false, locations: payload };
    case FETCH_LOCATIONS_FOR_REQUESTOR_FAILURE:
      return { ...state, loadingLocations: false, error: payload };
    case FETCH_UNPLANNED_LOCATIONS:
      return { ...state, loadingLocations: true, error: null };
    case FETCH_UNPLANNED_LOCATIONS_SUCCESS:
      return { ...state, loadingLocations: false, unplannedLocations: payload };
    case FETCH_UNPLANNED_LOCATIONS_FAILURE:
      return { ...state, loadingLocations: false, error: payload };
    case DELETE_HOO_REQUEST:
      return { ...state, loading: true, error: null };
    case DELETE_HOO_REQUEST_SUCCESS:
      return { ...state, loading: false };
    case DELETE_HOO_REQUEST_FAILURE:
      return { ...state, loading: false, error: payload };
    case ACCEPT_HOO_REQUEST:
      return { ...state, loading: true, error: null };
    case ACCEPT_HOO_REQUEST_SUCCESS:
      return { ...state, loading: false };
    case ACCEPT_HOO_REQUEST_FAILURE:
      return { ...state, loading: false, error: payload };
    case REJECT_HOO_REQUEST:
      return { ...state, loading: true, error: null };
    case REJECT_HOO_REQUEST_SUCCESS:
      return { ...state, loading: false };
    case REJECT_HOO_REQUEST_FAILURE:
      return { ...state, loading: false, error: payload };
    case SAVE_HOO_REQUEST:
      return { ...state, loading: true, error: null };
    case SAVE_HOO_REQUEST_FAILED:
      return { ...state, loading: false };
    case SAVE_HOO_REQUEST_FAILED:
      return { ...state, loading: false, error: payload };
    case FETCH_REQUEST_REASONS:
      return { ...state, loadingRequestReasons: true, error: null };
    case FETCH_REQUEST_REASONS_SUCCESS:
      return { ...state, loadingRequestReasons: false, requestReasons: payload };
    case FETCH_REQUEST_REASONS_FAILURE:
      return { ...state, loadingRequestReasons: false, error: payload };
    case FETCH_REQUEST_TYPES:
      return { ...state, loadingRequestTypes: true, error: null };
    case FETCH_REQUEST_TYPES_SUCCESS:
      return { ...state, loadingRequestTypes: false, requestTypes: payload };
    case FETCH_REQUEST_TYPES_FAILURE:
      return { ...state, loadingRequestTypes: false, error: payload };
    case EXPORT_HOO_REQUESTS:
      return { ...state, exportLoading: true, error: null };
    case EXPORT_HOO_REQUESTS_SUCCESS:
      return { ...state, exportLoading: false };
    case EXPORT_HOO_REQUESTS_FAILURE:
      return { ...state, exportLoading: false, error: payload };
    default:
      return state;
  }
};
